import { defineStore } from 'pinia'

interface State {
	errorMessage: string
	isFetching: boolean
	isShowing: boolean
}

export const usePrivacyInformationStore = defineStore('privacyInformation', {
  state: (): State => ({
		errorMessage: '',
		isFetching: false,
		isShowing: false,
	}),
	actions: {
		hide() {
			this.isShowing = false
		},
		show() {
			this.isShowing = true
		},
		toggle() {
			this.isShowing = !this.isShowing
		}
	}
})
